import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper } from '@mui/material';

type CarouselImage = {
  path: string;
  videoPath: string;
  favorite: boolean;
};

type PhotoCarouselProps = {
  images: CarouselImage[];
  itemName?: string;
};

export default function PhotoCarousel({
  images,
  itemName,
}: PhotoCarouselProps) {
  return (
    <Carousel
      sx={{
        p: 0,
        m: 0,
        '& .MuiPaper-root': { overflow: 'hidden', borderRadius: 'inherit' },
      }}
    >
      {images.map((item, index) => (
        <Item
          key={index}
          image={item?.path}
          video={item?.videoPath}
          itemName={itemName}
        />
      ))}
    </Carousel>
  );
}

type ItemProps = {
  image: string;
  video?: string;
  itemName?: string;
};

const Item: React.FC<ItemProps> = ({ image, video, itemName }) => {
  return (
    <Paper style={{ position: 'relative' }}>
      {image ? (
        <img
          src={image}
          alt="Tour Image"
          style={{
            display: 'block',
            width: '100%',
            height: '500px',
            objectFit: 'cover',
          }}
        />
      ) : (
        <video
          controls
          style={{
            display: 'block',
            width: '100%',
            height: '500px',
            objectFit: 'cover',
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
      )}
      {itemName && (
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            color: '#fff',
          }}
        >
          <h2>{itemName}</h2>
        </div>
      )}
    </Paper>
  );
};
